import moment from "moment";
import { saveAs } from "file-saver";

import ExcelJS from "exceljs";
import {
  numberToExcelColumn,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
  parseSheetName,
} from "./excel";

import { ModuleExpandIcon } from "../components/diagram/components";
import {
  FormInputtext,
  FormInputnumber,
  FormCalendar,
  FormDropdown,
  FormCheckbox,
} from "../components/formElement";
import { decimalAddZero, formatNumber } from "./common";
import { system_table } from "./system";
import { parseExcelDateToDate } from "./common";

import { Dropdown } from "primereact/dropdown";

// 產生列表欄位
export function createColumns({
  pageSize = system_table.size, // 每頁幾筆資料
  type = "", // 類型 (list: 列表、import: 匯入)
  saveType = "no", // 儲存類型 (no: 無、single: 單筆儲存、multi: 多筆儲存)
  saveFun = () => {}, // 儲存方法
  activeTemplate = [], // 生效的模組資料 (匯入匯出)
  defaultTemplate = {}, // 預設的模組欄位設定
  formSetting = {}, // 表單設定 (react-hook-form)
  frozenSetting = { frozen: false, align: "left", column: [] }, // 凍結設定
  optionData = {}, // 選單資料
  disabled = false, // 是否禁止編輯
} = {}) {
  let temp = [];
  activeTemplate.forEach((item, index) => {
    let columnSetting = defaultTemplate[item.apiKey] ?? {
        checked: true,
        isShow: true,
        uiType: "string",
        width: 150,
        listUI: false,
        importUI: true,
      }, // 預設的欄位設定
      isDisabled = columnSetting[`${type}Disabled`] || disabled,
      isUI = columnSetting[`${type}UI`];

    if (!item.checked || !columnSetting.isShow) return;

    let uiSetting = {
      field: item.apiKey,
      header: item.name,
      className: columnSetting.width
        ? `flex-grow-1 flex-basis-${columnSetting.width / 10} p-1 ${
            !isUI ? "flex align-items-center px-2" : ""
          }`
        : "",
      style: {
        width: columnSetting.width ?? "auto",
        minWidth:
          columnSetting.minWidth ??
          (columnSetting.width ? columnSetting.width - 20 : 100),
      },
    };

    // 凍結欄位設定
    if (
      frozenSetting.frozen &&
      frozenSetting.column.indexOf(item.apiKey) !== -1
    ) {
      uiSetting.frozen = frozenSetting.frozen;
      uiSetting.alignFrozen = frozenSetting.align;

      // 凍結分割陰影
      if (
        (frozenSetting.align === "left" &&
          frozenSetting.column.indexOf(item.apiKey) ===
            frozenSetting.column.length - 1) ||
        (frozenSetting.align === "right" &&
          frozenSetting.column.indexOf(item.apiKey) === 0)
      ) {
        uiSetting.style.boxShadow = `${
          frozenSetting.align === "left" ? "" : "-"
        }3px 1px 5px rgb(0 0 0 / 5%)`;
      }
    }
    let tempColumns = {};
    if (!isUI) {
      tempColumns = {
        ...uiSetting,
        body: (data) => (
          <>
            {columnSetting.uiType === "select" ? (
              <>
                {
                  optionData?.[`${columnSetting.options}_obj`]?.[
                    data[item.apiKey]
                  ]?.showLabel
                }
              </>
            ) : columnSetting.uiType === "date" &&
              columnSetting.dateFormatLabel ? (
              <>
                {data[item.apiKey]
                  ? moment(data[item.apiKey]).format(
                      columnSetting.dateFormatLabel
                    )
                  : null}
              </>
            ) : columnSetting.uiType === "number" ? (
              <>{data[item.apiKey]}</>
            ) : (
              <>
                {!data[item.apiKey]
                  ? ""
                  : typeof data[item.apiKey] !== "object"
                  ? data[item.apiKey]
                  : JSON.stringify(data[item.apiKey])}
              </>
            )}
          </>
        ),
      };
    } else if (columnSetting.uiType === "string") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormInputtext
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "number") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormInputnumber
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "date") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormCalendar
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                dateFormat: columnSetting.dateFormatUI,
                disabled: isDisabled || data.flag === "delete",
                showTime: !!columnSetting.showTime,
                showSeconds: !!columnSetting.showSeconds,
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "select") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormDropdown
              className="p-sm w-full"
              panelClassName="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                options: optionData[columnSetting.options],
                optionLabel: "showLabel",
                optionValue: "showValue",
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
                // showClear: false,
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "check") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormCheckbox
              className="m-0"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                label: "",
                type: "checked",
                value: true,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "pallet") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => <>pallet</>,
      };
    }

    temp.push(tempColumns);
  });
  return temp;
}

// 產生列表驗證設定
export function createSchema({
  type = "", // 類型(list: 列表、import: 匯入)
  activeTemplate = [], // 生效的模組資料(匯入匯出)
  defaultTemplate = {}, // 預設的模組欄位設定
  yup = null, // 表單驗證設定(react-hook-form)
} = {}) {
  let temp = {};
  activeTemplate.forEach((item, index) => {
    let columnSetting = defaultTemplate[item.apiKey] ?? {
        checked: true,
        isShow: true,
        uiType: "string",
        [`${type}UI`]: false,
      }, // 預設的欄位設定
      isUI = columnSetting[`${type}UI`];

    if (!item.checked || !columnSetting.isShow) return;

    // 有使用表單 UI 元件 且 必填 才需產生驗證設定
    if (!isUI || !columnSetting.required) return;

    if (columnSetting.uiType === "string") {
      temp[item.apiKey] = yup.string().required("必填");
    } else if (columnSetting.uiType === "number") {
      let tempSchema = yup.number().required("必填").nullable();
      if (columnSetting.min >= 0)
        tempSchema = tempSchema.moreThan(
          columnSetting.min,
          `需大於${columnSetting.min}`
        );
      temp[item.apiKey] = tempSchema;
    } else if (columnSetting.uiType === "date") {
      temp[item.apiKey] = yup.string().required("必填").nullable();
    } else if (columnSetting.uiType === "select") {
      temp[item.apiKey] = yup.string().required("必填").nullable();
    } else if (columnSetting.uiType === "check") {
      temp[item.apiKey] = yup.string().required("必填");
    }
  });

  return temp;
}

// 設定儲存資料 & 型態
export function formatTemplateColumns({
  type = "import", // import: 匯入、export: 匯出
  template = {}, // 模組資料
  data = [], // 儲存的資料
} = {}) {
  let tempData = [],
    tempColumns = Object.values(template);

  data.forEach((item) => {
    let row = {};
    tempColumns.forEach((column) => {
      let val = item[column[type === "import" ? "value" : "apiKey"]];

      if (val !== "" && val !== undefined && val !== null) {
        if (
          column.uiType === "number" ||
          (column.uiType === "select" && column.optionType === "number")
        ) {
          val = Number(val);
        } else if (column.uiType === "date" && column.dateFormatLabel) {
          if (typeof val === "number") val = parseExcelDateToDate(val);
          val = moment(val).format(column.dateFormatLabel);
        } else if (column.uiType === "check") {
          val = Boolean(val);
        } else {
          val = String(val);
        }

        if (type === "import" || (type === "export" && column.listUI)) {
          row[column.apiKey] = val;
        }
      }
    });
    tempData.push(row);
  });

  return tempData;
}

// 頁碼設定
export const ModuleTablePaginator = {
  layout:
    "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  RowsPerPageDropdown: (options) => {
    const dropdownOptions = [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      // { label: "All", value: options.totalRecords },
    ];

    return (
      <Dropdown
        value={options.value}
        options={dropdownOptions}
        onChange={options.onChange}
      />
    );
  },
};

/*
  整理展開標題欄位
  @params columns: 欄位
  @params expandChild: 展開子欄位
  @params tbExpandColumns: 目前展開欄位
  @params handleTbExpand(): 展開函式
*/
export function formatTbExpandColumns({
  rootColumns = [],
  expandColumns = [],
  tbExpandColumns = {},
  handleTbExpand,
} = {}) {
  let isExpand = Object.values(tbExpandColumns).some((item) => item);
  return rootColumns.map((rtColumn) => ({
    key: rtColumn.key,
    field: `${rtColumn.key}${rtColumn.isNumber ? "_format" : ""}`,
    header: () => (
      <div>
        <ModuleExpandIcon
          handleExpand={() => handleTbExpand({ key: rtColumn.prefixKey })}
        />
        <span>{rtColumn.headerName}</span>
      </div>
    ),
    headerRaw: rtColumn.headerName,
    className: rtColumn.className,
    colSpan: tbExpandColumns[rtColumn.prefixKey]
      ? rtColumn.colSpan ?? expandColumns.length
      : rtColumn.colSpan ?? 1,
    rowSpan:
      tbExpandColumns[rtColumn.prefixKey] || !isExpand
        ? rtColumn.rowSpan ?? 1
        : rtColumn.rowSpan ?? 2,
    isExpand: !!tbExpandColumns[rtColumn.prefixKey],
    child: expandColumns.map((epColumn) => ({
      key: `${rtColumn.prefixKey}_${epColumn.suffixKey}`,
      field: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
        epColumn.isNumber ? "_format" : ""
      }`,
      header: epColumn.name,
      className: epColumn.className,
      colSpan: epColumn.colSpan ?? 1,
      rowSpan: epColumn.rowSpan ?? 1,
      child: epColumn.child?.map((ep2Column) => ({
        key: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
          ep2Column.suffixKey ? `_${ep2Column.suffixKey}` : ""
        }`,
        field: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
          ep2Column.suffixKey ? `_${ep2Column.suffixKey}` : ""
        }${ep2Column.isNumber ? "_format" : ""}`,
        header: ep2Column.name,
        className: ep2Column.className,
      })),
    })),
  }));
}

/*
  下載 Excel
  @params moduleTitle?: 標題
  @params progressAction(flag): loading 開關 Fun (flag: true/false)
*/
export const exportTableExcel = async (options) => {
  const { exportType, moduleTitle, progressAction } = options;

  const defaultTitle = "匯出表格";

  const workbook = new ExcelJS.Workbook();

  if (exportType === "table") {
    // 匯出表格
    createTableExcelSheet({ workbook, defaultTitle, ...options });
  } else if (exportType === "list") {
    // 匯出清單
    createListExcelSheet({ workbook, defaultTitle, ...options });
  }

  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });
  saveAs(mainBlob, (moduleTitle ?? defaultTitle) + ".xlsx");

  setTimeout(() => {
    progressAction(false);
  }, 1000);
};

/*
  建立 List workbook sheet
  @params workbook: Excel 對象
  @params defaultTitle: 預設標題
  @params moduleTitle?: 標題
  @params tbCellClass: 欄位樣式
  @params tbData: 表格主體資料
  @params exportColumns: 匯出欄位
*/
const createListExcelSheet = ({
  workbook,
  defaultTitle,
  moduleTitle,
  exportColumns,
  tbData,
}) => {
  let ws = workbook.addWorksheet(parseSheetName(moduleTitle ?? defaultTitle)),
    columnsMerge = [],
    columnWidth = [],
    columnHeight = [],
    columnIdx = {
      col: -1,
      row: 0,
    },
    commonStyle = {
      align_h: "center",
      border_color: "d0cece",
    };

  // 表格大標題
  if (moduleTitle) {
    columnIdx.row++;
    createXlsxColumn({
      ws,
      column: `A${columnIdx.row}`,
      value: moduleTitle,
      styles: createXlsxCellStyle({
        ...commonStyle,
        font_color: "ffffff",
        font_bold: true,
        fill_color: "6ca9cf",
        align_h: "left",
      }),
    });
    columnsMerge.push({
      column: `A${columnIdx.row}:${numberToExcelColumn(exportColumns.length)}${
        columnIdx.row
      }`,
    });
    columnHeight.push({ column: 1, height: 20 });
  }

  // 標題列
  columnIdx.row++;
  exportColumns.forEach((column, cIdx) => {
    createXlsxColumn({
      ws,
      column: `${numberToExcelColumn(cIdx + 1)}${columnIdx.row}`,
      value: column.label,
      styles: createXlsxCellStyle({
        ...commonStyle,
        font_bold: true,
        fill_color: "e9f3f9", // 01B468
      }),
    });
  });

  // 表格內容
  tbData.export.forEach((rows, rIdx) => {
    columnIdx.row++;
    exportColumns.forEach((column, cIdx) => {
      createXlsxColumn({
        ws,
        column: `${numberToExcelColumn(cIdx + 1)}${columnIdx.row}`,
        value: String(rows[column.key]),
        styles: createXlsxCellStyle({
          ...commonStyle,
          fill_color: rIdx % 2 === 1 ? "f2f2f2" : "ffffff",
        }),
      });
    });
  });

  for (let i = 0; i < exportColumns.length; i++) {
    columnWidth.push({ column: numberToExcelColumn(i + 1), width: 15 });
  }
  createColumnWidth({
    ws,
    columns: columnWidth,
  });

  createColumnHeight({
    ws,
    columns: columnHeight,
  });

  createColumnMerge({
    ws,
    columns: columnsMerge,
  });
};

/*
  建立 Table workbook sheet
  @params workbook: Excel 對象
  @params defaultTitle: 預設標題
  @params moduleTitle?: 標題
  @params tbCellClass: 欄位樣式
  @params tbData: 表格主體資料
  @params tbHead: 表格 head 欄位
  @params tbBody: 表格 body 欄位
  @params tbFoot: 表格 foot 欄位
  @params tbExpandColumns: 表格展開欄位
  @params nullTransfer: null資料轉換
*/
const createTableExcelSheet = ({
  workbook,
  defaultTitle,
  moduleTitle,
  tbCellClass,
  setting,
  tbData,
  tbHead,
  tbBody,
  tbFoot,
  tbExpandColumns,
  nullTransfer,
}) => {
  let ws = workbook.addWorksheet(parseSheetName(moduleTitle ?? defaultTitle)),
    columnsMerge = [],
    columnWidth = [],
    columnHeight = [],
    columnIdx = {
      col: -1,
      row: 0,
    },
    commonStyle = {
      align_h: "center",
      border_color: "d0cece",
    },
    colLength = tbHead.columns[0].reduce(
      (pre, cur) => (pre += cur.colSpan ?? 1),
      0
    ),
    rowLength = tbHead.columns.length,
    groupKeys = (setting.groupColumns || []).map((column) => column.key);

  // 表格大標題
  if (moduleTitle) {
    columnIdx.row++;
    createXlsxColumn({
      ws,
      column: `A${columnIdx.row}`,
      value: moduleTitle,
      styles: createXlsxCellStyle({
        ...commonStyle,
        font_color: "ffffff",
        font_bold: true,
        fill_color: "6ca9cf",
        align_h: "left",
      }),
    });
    columnsMerge.push({
      column: `A${columnIdx.row}:${numberToExcelColumn(colLength)}${
        columnIdx.row
      }`,
    });
    columnHeight.push({ column: 1, height: 20 });
  }

  // 表格欄位 header
  createTableExcelHeadFoot({
    ws,
    key: "header",
    columns: tbHead.columns,
    columnIdx,
    columnsMerge,
    commonStyle,
    colLength,
    rowLength,
  });

  // 表格內容
  (tbData.export || tbData.format).forEach((rows, rIdx) => {
    columnIdx.col = 0;
    columnIdx.row++;
    tbBody.columns.forEach((column) => {
      createXlsxColumn({
        ws,
        column: `${numberToExcelColumn(columnIdx.col + 1)}${columnIdx.row}`,
        value: `${
          rows[column.key] === null || rows[column.key] === undefined
            ? nullTransfer
            : rows[column.key]
        }${column.key.includes("_percent") && rows[column.key] ? "%" : ""}`,
        styles: createXlsxCellStyle({
          ...commonStyle,
          font_bold: ["total_row", "total_row_percent"].includes(column.key),
          fill_color:
            groupKeys.includes(column.key) && !rows.isFoot
              ? "fff3e1"
              : ["total_row", "total_row_percent"].includes(column.key) ||
                !!rows.isFoot
              ? "e9f3f9"
              : rIdx % 2 === 1
              ? "f2f2f2"
              : "ffffff",
        }),
      });

      if (
        rows[`colSpan_${column.key}`] > 1 ||
        rows[`rowSpan_${column.key}`] > 1
      ) {
        columnsMerge.push({
          column: `${numberToExcelColumn(columnIdx.col + 1)}${
            columnIdx.row
          }:${numberToExcelColumn(
            columnIdx.col + (rows[`colSpan_${column.key}`] ?? 1)
          )}${columnIdx.row + (rows[`rowSpan_${column.key}`] ?? 1) - 1}`,
        });
      }

      columnIdx.col++;
    });
  });

  if (setting.isColSum) {
    // 表格欄位 footer
    createTableExcelHeadFoot({
      ws,
      key: "footer",
      columns: tbFoot.columns,
      columnIdx,
      columnsMerge,
      commonStyle,
      colLength,
      rowLength,
    });
  }

  for (let i = 0; i < colLength; i++) {
    columnWidth.push({ column: numberToExcelColumn(i + 1), width: 15 });
  }
  createColumnWidth({
    ws,
    columns: columnWidth,
  });

  createColumnHeight({
    ws,
    columns: columnHeight,
  });

  createColumnMerge({
    ws,
    columns: columnsMerge,
  });
};

/*
  建立 Table workbook sheet header 或 footer
  @params ws: Excel Sheet
  @params key: 類型 (header/footer)
  @params columns: 欄位
  @params columnIdx: 欄位位置(col: 行, row: 列)
  @params columnsMerge: 合併欄位
  @params commonStyle: 欄位共用樣式
  @params colLength: 行數
  @params rowLength: 列數
*/
const createTableExcelHeadFoot = ({
  ws,
  key,
  columns,
  columnIdx,
  columnsMerge,
  commonStyle,
  colLength,
  rowLength,
}) => {
  if (!columns) return;

  let matrix = [];
  for (let i in Array.from({ length: rowLength })) {
    matrix.push(Array.from({ length: colLength }));
  }

  columns.forEach((rows, rIdx) => {
    columnIdx.row++;
    rows.forEach((column) => {
      let startIndex = matrix[rIdx].findIndex((item) => !item);
      createXlsxColumn({
        ws,
        column: `${numberToExcelColumn(startIndex + 1)}${columnIdx.row}`,
        value: `${
          key === "footer" && !!column.isFootSumHide
            ? ""
            : `${column[key]}${
                key === "footer" && column.key.includes("_percent") ? "%" : ""
              }`
        }`,
        styles: createXlsxCellStyle({
          ...commonStyle,
          font_bold: true,
          fill_color: key === "header" ? "e9f3f9" : "e9f3f9",
        }),
      });
      if (column.colSpan > 1 || column.rowSpan > 1) {
        columnsMerge.push({
          column: `${numberToExcelColumn(startIndex + 1)}${
            columnIdx.row
          }:${numberToExcelColumn(startIndex + (column.colSpan ?? 1))}${
            columnIdx.row + (column.rowSpan ?? 1) - 1
          }`,
        });
      }

      for (let c = startIndex; c < startIndex + column.colSpan; c++) {
        for (let r = rIdx; r < rIdx + column.rowSpan; r++) {
          matrix[r][c] = true;
        }
      }
    });
  });
};

/*
  整理數字欄位
  @params data: 轉換資料
  @params columns: 欄位
*/
export function formatTbNumberColumns({
  data = [],
  columns = [],
  nullTransfer = 0,
} = {}) {
  return data.map((item) => {
    let row = { ...item };
    columns.forEach((column) => {
      row[`${column}_format`] =
        row[column] === null
          ? nullTransfer
          : decimalAddZero({
              rawVal: formatNumber(row[column]),
              decimalShowRaw: true,
            });
    });
    return row;
  });
}

/*
  整理數字欄位
  @params data: 轉換資料
  @params columns: 欄位
*/
export function formatTbPercent({
  data = [],
  columns = [],
  nullTransfer = 0,
} = {}) {
  if (!data[0]) return data;

  let total = columns.reduce((pre, cur) => ({ ...pre, [cur]: 0 }), {});
  columns.forEach((column) => {
    data.forEach((item) => (total[column] += item[column]));
  });
  data.forEach((item) => {
    columns.forEach((column) => {
      let percent = Math.round((item[column] * 100) / total[column]);
      item[`${column}_percent`] = percent;
      item[`${column}_percent_format`] = `${percent}%`;
    });
  });
  return data;
}

/*
  計算總和
  @params isPercent: 是否計算百分比
  @params data: 轉換資料
  @params columns: 欄位
*/
export function calculateTbSum({
  isPercent = false,
  data = [],
  columns = [],
  nullTransfer = "",
} = {}) {
  // 各列 全部欄位資料加總
  let formatData = data.map((item) => ({
    ...item,
    total_row:
      item.total_row === null || item.total_row === undefined
        ? columns.reduce(
            (pre, cur) =>
              (pre += isNaN(item[cur.key]) || cur.isSkip ? 0 : item[cur.key]),
            0
          )
        : item.total_row,
  }));
  // 各行 全部欄位資料加總
  let footData = { total_row: 0, total_row_percnet: 100 };
  formatData.forEach((item) => {
    columns.forEach((column) => {
      if (column.key.includes("total_")) return;

      let value = Number(item[column.key] ?? 0);
      if (!footData[column.key]) footData[column.key] = 0;
      if (!item.isSkip) footData[column.key] += value;
    });
    if (!item.isSkip) footData.total_row += Number(item.total_row ?? 0);
  });

  // 各列 全部欄位計算百分比
  formatData = formatData.map((item) => ({
    ...item,
    ...columns.reduce(
      (pre, cur) => ({
        ...pre,
        [`${cur.key}_format`]:
          isNaN(item[cur.key]) ||
          item[cur.key] === null ||
          item[cur.key] === undefined
            ? nullTransfer
            : decimalAddZero({
                rawVal: formatNumber(item[cur.key]),
                decimalShowRaw: true,
              }),
        [`${cur.key}_percent`]:
          isNaN(item[cur.key]) || item[cur.key] === 0
            ? 0
            : Math.round((item[cur.key] / footData[cur.key]) * 100),
      }),
      {}
    ),
  }));

  // 各行 全部欄位計算百分比
  footData = {
    ...footData,
    ...Object.entries(footData).reduce(
      (pre, cur) => ({
        ...pre,
        [`${cur[0]}_percent`]: isNaN(cur[1]) || cur[1] === 0 ? 0 : 100,
        [`${cur[0]}_format`]: isNaN(cur[1])
          ? "-"
          : decimalAddZero({
              rawVal: formatNumber(cur[1]),
              decimalShowRaw: true,
            }),
      }),
      {}
    ),
  };

  return {
    formatData,
    footData,
  };
}
